<template>
  <div class="row">
    <div class="col-xl-12">
      <container-headline
        class="col-xl-12"
        :headline="$t('global.contact') + ' (' + kontakteCount + ')'"
        :col="3"
      >
        <div class="row mt-2 d-flex justify-content-between">
          <div class="ml-4">
            <button
              class="btn btn-success mr-2"
              @click="neuerKontakt"
              v-if="editable"
            >
              <font-awesome-icon icon="fa-duotone fa-ticket" class="mr-2" />
              {{ $t("global.newcontact") }}
            </button>
          </div>
          <div class="mr-4">
            <button
              class="btn btn-danger"
              @click="oeffneLoeschenModal"
              v-if="editable"
            >
              <font-awesome-icon class="mr-2" icon="fa-duotone fa-trash" />
              <span>{{ $t("global.delete") }}</span>
            </button>
          </div>
        </div>
      </container-headline>
      <div class="row col-xl-12">
        <div class="col-xl-12 block belegliste br-t-l-0">
          <div>
            <div>
              <b-table
                ref="selectableTable"
                tbody-tr-class="item"
                style="max-height: 300px"
                responsive
                sticky-header
                :items="kontakte"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                sort-icon-left
                selectable
                select-mode="range"
                @row-dblclicked="details"
              >
                <template v-slot:head(selected)="row">
                  <b-form-checkbox
                    v-model="row.selected"
                    @input="selectAllRows(row)"
                  ></b-form-checkbox>
                </template>
                <template v-slot:cell(selected)="row">
                  <b-form-checkbox
                    v-model="row.item.selected"
                    @input="onRowSelected(row)"
                  ></b-form-checkbox>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <loeschen-modal
      id="kontakt-loeschen-modal"
      @confirmed="kontaktPersonLoeschen"
      :selectedIds="selectedIds"
    />

    <lead-kontakt-modal
      @kontaktCreated="kontaktErstellt"
      @kontaktChanged="kontaktGeaendert"
    />
  </div>
</template>

<script>
import Api from "@/api/Api";
import ContainerHeadline from "@/components/ContainerHeadline";
import LeadKontaktModal from "@/components/crm/LeadKontaktModal";
import LoeschenModal from "@/components/Modals/LoeschenModal";

import reiter from "@/mixins/Reiter";
import { apiErrorToAlert } from "@/utils/Errorhandler";

export default {
  components: {
    ContainerHeadline,
    LoeschenModal,
    LeadKontaktModal,
  },
  mixins: [reiter],
  props: {
    lead: {
      type: String,
      required: false,
    },
    editable: {
      type: Boolean,
      required: true,
    },
    shown: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      page: 0,
      anzahlProPage: 200,
      kontakte: [],
      kontakteCount: 0,
      selectedIds: [],
      sortBy: "person.personName",
      sortDesc: false,
    };
  },
  watch: {
    shown(val) {
      if (val && this.kontakte.length == 0) this.getLeadKontakte();
    },
  },
  computed: {
    fields() {
      return [
        { key: "selected", label: "" },
        {
          key: "person.name",
          sortable: true,
          label: this.$t("global.person"),
        },
        {
          key: "person.vorname",
          sortable: true,
          label: this.$t("global.firstname"),
        },
        { key: "firma.name", sortable: true, label: this.$t("global.company") },
        {
          key: "rolle.bezeichnung",
          sortable: true,
          label: this.$t("global.role"),
        },
      ];
    },
    queryParams: function () {
      var params = {
        page: this.page,
        count: this.anzahlProPage,
      };

      return params;
    },
  },
  mounted() {
    if (this.shown) this.getLeadKontakte();
  },
  created() {},
  methods: {
    getLeadKontakte() {
      Api.get("crm/lead/kontaktperson/", {
        params: {
          lead: this.lead,
          page: this.page,
          count: this.anzahlProPage,
        },
      }).then((response) => {
        this.kontakte = response.data;
        this.kontakteCount = this.kontakte.length;
      });
    },

    details(kontakt) {
      this.$bus.$emit("lead-kontakt-modal-show", kontakt);
    },

    neuerKontakt() {
      this.$bus.$emit("lead-kontakt-modal-show", null);
    },

    oeffneLoeschenModal() {
      if (this.selectedIds.length > 0)
        this.$bus.$emit("openLoeschenModal", "kontakt-loeschen-modal");
      else {
        this.$notify({
          type: "warn",
          title: this.$t("global.actionfailed"),
          text: this.$t("global.nocontactsselectedfordeletion"),
        });
      }
    },

    kontaktPersonLoeschen() {
      Api.delete("crm/lead/kontaktperson/", {
        params: { ids: this.selectedIds.join(",") },
      }).then(() => {
        this.getLeadKontakte();
      });
    },

    kontaktErstellt(kontakt) {
      let json = kontakt;
      json.lead = this.lead;

      Api.post("crm/lead/kontaktperson/", json)
        .then(() => {
          this.getLeadKontakte();
          this.$notify({
            type: "success",
            title: this.$t("global.actionsuccessful"),
            text: this.$t("global.contactsavedsuccessfully"),
          });
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
        })
        .finally(() => {
          this.loading = false;
        });
    },

    kontaktGeaendert(kontakt) {
      let json = kontakt;
      json.lead = this.lead;

      Api.put("crm/lead/kontaktperson/", json, { params: { id: kontakt.id } })
        .then(() => {
          this.getLeadKontakte();
          this.$notify({
            type: "success",
            title: this.$t("global.actionsuccessful"),
            text: this.$t("global.contactsavedsuccessfully"),
          });
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
